const state = {
    tab: 'TradingAnalysis'
}

const mutations = {    
    setTab(state, flag) {
        state.tab = flag
    }
}

const getters = {    
    tab: state => {       
        return state.tab
    }
}

const actions = {   
    setTab({ commit }, flag) {
        commit("setTab", flag)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/portfolioreport.js